import { Link, useNavigate } from "react-router";
import { toast } from "sonner";
import { ChevronRight, CreditCard, LogOut, User } from "lucide-react";
import { useMe, useLogout } from "@/lib/auth";
import { useTranslation } from "@/lib/i18n";
import { MmCard, MmPage } from "./shared";

/** MindfulMe profile: email, link to subscription management, log out. */
export function MindfulMeProfile() {
  const { t } = useTranslation();
  const { data: me } = useMe();
  const logout = useLogout();
  const navigate = useNavigate();

  async function handleLogout() {
    try {
      await logout.mutateAsync();
      toast.success(t("profile_logged_out"));
      navigate("/login", { replace: true });
    } catch {
      toast.error(t("profile_logout_failed"));
    }
  }

  return (
    <MmPage backTo="/report" backLabel={t("mm_back")} title={t("mm_profile_title")}>
      <MmCard className="mt-6 flex items-center gap-4 p-5">
        <span className="grid size-14 shrink-0 place-items-center rounded-full bg-indigo-50 text-slate-800">
          <User className="size-6" aria-hidden="true" />
        </span>
        <div className="min-w-0">
          <p className="text-sm text-slate-500">{t("mm_email")}</p>
          <p className="truncate text-lg font-bold text-slate-900">{me?.email}</p>
        </div>
      </MmCard>

      <Link to="/profile/subscription" className="mt-6 block">
        <MmCard className="flex items-center gap-3 px-5 py-4 transition-colors hover:bg-slate-50">
          <CreditCard className="size-5 text-slate-600" aria-hidden="true" />
          <span className="flex-1 text-base text-slate-800">{t("mm_manage_sub")}</span>
          <ChevronRight className="size-5 text-slate-500" aria-hidden="true" />
        </MmCard>
      </Link>

      <div className="mt-8 flex justify-center">
        <button
          type="button"
          onClick={handleLogout}
          disabled={logout.isPending}
          className="inline-flex items-center gap-2 text-base text-slate-700 transition-colors hover:text-slate-900 disabled:opacity-60"
        >
          <LogOut className="size-4" aria-hidden="true" />
          {logout.isPending ? t("profile_signing_out") : t("mm_log_out")}
        </button>
      </div>
    </MmPage>
  );
}
